import React from "react";
import i18n from "../../../../variables/translations/i18n";
import { Container } from "reactstrap";
import { Redirect } from "react-router";
import urls from "urls";
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import {isAdminPage} from "../../../functions/generic";
import AlertWithCancel from "../../../../components/Notifications/AlertWithCancel";
import PaymentLoading from "../../../../components/Loading/payment";
import {cancelSubscription, fetchSubscription} from "../../../functions/stripe/subscription";

class CancelSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: localStorage.getItem("compid"),
      showCancelAlert: true,
      proceedWithCancel: null,
      cancelSucceeded: null,
      authorized: this.props.location.authorized,
      subscriptionType: this.props.location.subscriptionType,
      isLoading: false,
    };
  }

  /**
   * Cancel subscription in Payment API
   */
  confirmCancelSubscription() {
    this.setState({proceedWithCancel: true, showCancelAlert: null, isLoading:true})
    fetchSubscription(this.state.companyId).then((subscription) => {
      cancelSubscription(subscription.subscriptionId)
        .then(() => this.setState({isLoading: false, cancelSucceeded: true}))
        .catch(() => this.setState({isLoading: false, cancelSucceeded: false}))
    })
  }

  render() {
    const { cancelSucceeded, showCancelAlert, authorized, proceedWithCancel, isLoading } = this.state;
    if (cancelSucceeded === true) return <Redirect to={{pathname: urls.subscription, cancelDone: true}} />;
    if (cancelSucceeded === false) return <Redirect to={{pathname: urls.subscription, cancelDone: false}} />;
    if (!authorized || proceedWithCancel === false) return <Redirect to={{pathname: urls.subscription}} />;
    return (
      <>
        <SimpleHeader
          name={i18n.t("dashboard.abonnement.abonnement_titel")}
          parentName={i18n.t("dashboard.bedrijf")}
          isAdminPage={isAdminPage(this.props.location.pathname)}
        />
        <Container className="mt--8 pb-5">
          {isLoading &&
          <PaymentLoading/>
          }
          {showCancelAlert &&
          <AlertWithCancel
            type="warning"
            title={i18n.t("dashboard.abonnement.opzeggen_bevestigings_vraag_titel")}
            description={i18n.t("dashboard.abonnement.opzeggen_bevestigings_vraag_descr")}
            confirmBtnText={i18n.t("dashboard.abonnement.abonnement_opzeggen_btn")}
            confirmAlert={() => this.confirmCancelSubscription()}
            closeAlert={() => this.setState({proceedWithCancel: false, showCancelAlert: null})}
            cancelBtnText={i18n.t("dashboard.sluiten")}
          />
          }
        </Container>
      </>
    );
  }
}

export default CancelSubscription;
